import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa6';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TableSortButtonProps {
    active: boolean;
    direction?: 'asc' | 'desc';
    onClick: () => void;
    disabled?: boolean;
    className?: string;
}

export function TableSortButton({ active, direction, onClick, disabled, className }: TableSortButtonProps) {
    const ariaLabel = active
        ? direction === 'asc'
            ? 'Sortare ascendentă activă. Click pentru sortare descendentă'
            : 'Sortare descendentă activă. Click pentru sortare ascendentă'
        : 'Sortare inactivă. Click pentru sortare ascendentă';

    return (
        <Button
            variant="ghost"
            size="sm"
            onClick={onClick}
            disabled={disabled}
            className={cn("ecotic-sort-button", className)}
            type="button"
            aria-label={ariaLabel}
        >
            {!active && <FaSort className="ecotic-sort-icon" />}
            {active && direction === 'asc' && <FaSortUp className="ecotic-sort-icon-active" />}
            {active && direction === 'desc' && <FaSortDown className="ecotic-sort-icon-active" />}
        </Button>
    );
}
